// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"265":"31c94f4e","513":"0e838ac9","703":"5343515f"}[chunkId] + ".chunk.js";
};